import React from 'react';
import { useSelector } from 'react-redux';
import getParameterFromURL from '../../utils/scripts/getParameterFromURL';
import store from '../../store';
import s from './index.module.scss';

function ProgressBar() {
  const currentStepIndex = useSelector((state) => state.steps.currentStepIndex);
  const totalSteps = useSelector((state) => state.steps.totalSteps);
  const customV1Style = getParameterFromURL('config') === 'customV1';
  const { currentStep } = store.getState().steps;
  const hideElement = currentStep === 'customV1_loader' ? s.hideElement : '';

  return (
    customV1Style ? (
      <div className={`${s.progressBar} ${hideElement}`} style={{ '--step': currentStepIndex, '--totalSteps': totalSteps }}>
        <div className={s.progressBarDividers}>
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
          <div className={s.progressBarDivider} />
        </div>
      </div>
    ) : (
      <div className={s.progressBar} style={{ '--step': currentStepIndex, '--totalSteps': totalSteps }} />
    )
  );
}

export default ProgressBar;
